import * as Y from 'yjs';

import { WidgetType } from 'shared/widgets/utils';

import { ManifestInitializedProps } from '@/types/ManifestType';
import { genRandId } from '@/utils/core.utils';
import { LinkTargetType, ObjectFit } from '@/widgets/Image/types';

export function createNewImageData(): ManifestInitializedProps {
  const id = genRandId();
  return [
    {
      id,
      contentObjectData: new Y.Map([
        ['id', id],
        ['type', WidgetType.Image],
        ['children', new Y.Array()],
        ['src', ''],
        ['alt', ''],
        ['mobileSrc', ''],
        ['objectFit', ObjectFit.Contain],
        ['mobileObjectFit', ObjectFit.Contain],
        ['goToLink', ''],
        ['goToLinkTitle', ''],
        ['goToPage', ''],
        ['goToPageTitle', ''],
        ['linkTargetType', LinkTargetType.SameWindow],
        ['goToType', null],
        ['isDecorative', false]
      ])
    }
  ];
}
